import { useState } from "react";
import styled from "styled-components";

interface PaginationProps {
  maxWidth?: string;
  left?: string;
  transform?: string;
  onSubmit(value: any, event: any): void;
  pages: Page[];
}

type Page = {
  page: number,
  selected: boolean
}
interface PageProps {
  selected?: boolean;
  dot?: boolean;
}
interface PageListProps {
  maxWidth?: string;
  left?: string;
  transform?: string;
}
export function Pagination({ onSubmit, maxWidth, left, transform, pages }: PaginationProps) {
  const [selectedID, setSelectedID] = useState<number>(0);

  // let lastEvent: any = null;
  // let lastTimeout: NodeJS.Timeout|null = null;

  function tranformListPages(pages: Page[]): Page[] {
    if(pages.length < 7) return pages;

    let selected: number = pages.findIndex((p) => p.selected);
    selected = selected < 3? 3 : selected;
    selected = selected > pages.length - 4? pages.length - 4 : selected;

    const gap = (i: number, select: number) => {
      if(Math.abs(i - select) === 2){
        return true;
      }
      return false;
    }

    const nullPage: Page = {
      page: -1,
      selected: false
    }
    
    return [pages[0], gap(1, selected)? pages[1] : nullPage, pages[selected-1], pages[selected], pages[selected+1], gap(pages.length-2, selected)? pages[pages.length-2] : nullPage, pages[pages.length-1]] ;
  }

  // function handleClick(id: number, event: any) {
  //   event.preventDefault();
  //   lastTimeout && clearTimeout(lastTimeout);
  //   selectedID = id;
  //   lastEvent = event;
  //   lastTimeout = setTimeout(delaySubmit, 1000);
  // }
  // function delaySubmit() {
  //   if (onSubmit) {
  //     onSubmit(pages[selectedID].page, lastEvent)
  //   }
  // }

    function handleClick(id: number, event: any) {
      event.preventDefault();
      setSelectedID(id);
      onSubmit(pages[id].page, event);
    }

  return (
    <PageList
      maxWidth={maxWidth}
      left={left}
      transform={transform}
    >
      
      {pages.length > 2? (
        <PageButton disabled={selectedID === 0} onClick={(e) => {handleClick(selectedID - 1, e)}}>{'<'}</PageButton>
      ) : (
        <></>
      )}
      {tranformListPages(pages).map((page: Page, i: number) => (
          <PageButton disabled={page.page < 0} selected={page.selected} dot={page.page < 0} onClick={(e) => {handleClick(page.page -1, e)}}>{page.page < 0? '...' : page.page}</PageButton>
      ))
      }
      {pages.length > 2? (
        <PageButton disabled={selectedID === pages.length-1} onClick={(e) => {handleClick(selectedID + 1, e)}}>{'>'}</PageButton>
      ) : (
        <></>
      )}
    </PageList>
  )
}

export const PageButton = styled.button<PageProps>`
  min-width: 25px;
  padding: 0px 6px;
  display: inline-block;
  background-color: ${({ theme, selected, dot, disabled }) => dot? '' : disabled? theme.colors.gray.darker : selected? '#fff' : theme.colors.blue.dark };
  color: ${({ theme, selected, dot }) => dot? theme.colors.blue.dark : selected? theme.colors.pink.light : theme.colors.gray.light };
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  max-width: max-content;
  height: 36px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: ${({ theme, selected }) => selected? `2px solid ${theme.colors.gray.darker}` : 'none' };
  bottom: 0;
  cursor: ${({ dot, disabled, selected }) => dot || disabled || selected? 'auto' : 'pointer' };
  margin-right: 10px;
`;
  
const PageList = styled.ul<PageListProps>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth? `${maxWidth}` : '100%'};
  height: 40px;
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin-bottom: 32px;
  left: ${({ left }) => left? `${left}` : '0%'};
  transform: ${({ transform }) => transform? `${transform}` : 'translate(0%, 0%)'};
  position: absolute;

`;